import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Collapse } from '@mui/material';
import NavItem from './NavItem';
import { PATH_MASTERS } from '../../../routes/paths';
import useActiveLink from '../../../hooks/useActiveLink';
import { useAppStore } from '../../../store/appStore';
import {useApproverStore } from '../../../pages/ApproverOnLeave/approverStore/approverAppStore'


NavList.propTypes = {
    userMenu: PropTypes.object,
    depth: PropTypes.number,
    hasChild: PropTypes.bool,
    activePath: PropTypes.string,
    onActivePathChange: PropTypes.func,
    userPath: PropTypes.any
};

export default function NavList({ userMenu, depth, hasChild, activePath, onActivePathChange, userPath }) {
    const {
        destroy
    } = useAppStore();
    const {
        destroy : destroy1
    } = useApproverStore();

    const commonPath = PATH_MASTERS.root;
    
    const { activee, isExternalLink } = useActiveLink(commonPath);
    
    const [open, setOpen] = useState(false);
    useEffect(() => {
        if (!activee) {
            handleClose();
        }
        if (activePath === userMenu.route) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [activePath, userMenu.route, activee]);

    const handleToggle = (event) => {
        const newPath = userMenu.route;
        const pathId = userPath?.map(value =>
            event.target.innerHTML

        );
        const isLeafNode = !userMenu.children || userMenu.children.length === 0;
        const isNewRoute = activePath !== newPath;
        
        if (isLeafNode) {
            window.dispatchEvent(new Event('hideSidebarEvent'));
        }

        if (isLeafNode && isNewRoute) {
            console.log("destroyed");
            destroy();
            destroy1();
        }
            
        if (pathId) {
            onActivePathChange(newPath); 
        }
        setOpen(!open)
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <>
            <NavItem
                item={userMenu}
                depth={depth}
                open={open}
                active={activePath === userMenu.route}
                isExternalLink={isExternalLink}
                onClick={handleToggle}
            />
            {hasChild && userMenu.children && (
                <Collapse in={open} unmountOnExit>
                    <NavSubList
                        userMenu={userMenu.children}
                        activee={activee}
                        depth={depth + 1}
                        activePath={activePath}
                        onActivePathChange={onActivePathChange}
                    />
                </Collapse>
            )}
        </>
    );
}

// ----------------------------------------------------------------------

NavSubList.propTypes = {
    userMenu: PropTypes.array,
    depth: PropTypes.number,
    activePath: PropTypes.string,
    onActivePathChange: PropTypes.func,
};

function NavSubList({ userMenu, depth, activePath, onActivePathChange }) {
    return (
        <>
            {userMenu && userMenu.map((list) => (
                <NavList
                    key={list.displayName + list.route}
                    userMenu={list}
                    depth={depth + 1}
                    hasChild={!!list.children}
                    activePath={activePath}
                    onActivePathChange={onActivePathChange}
                />
            ))}
        </>
    );
}

